import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const LinkBrokenIcon: FC<AllieIconProps> = ({ allieColor = 'primary-60' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_7410_102)">
      <path
        // eslint-disable-next-line max-len
        d="M7.49996 3.33333V1.66666M12.5 16.6667V18.3333M3.33329 7.5H1.66663M16.6666 12.5H18.3333M4.09514 4.09518L2.91663 2.91666M15.9048 15.9048L17.0833 17.0833M9.99996 14.714L8.23219 16.4818C6.93045 17.7836 4.81989 17.7836 3.51815 16.4818C2.2164 15.1801 2.2164 13.0695 3.51815 11.7678L5.28591 10M14.714 10L16.4818 8.23223C17.7835 6.93048 17.7835 4.81993 16.4818 3.51819C15.18 2.21644 13.0695 2.21644 11.7677 3.51819L9.99996 5.28595"
        stroke={`var(--allie-color-${allieColor})`}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7410_102">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
